import { render, staticRenderFns } from "./ProjectChooser.vue?vue&type=template&id=32eba71b&scoped=true&"
import script from "./ProjectChooser.vue?vue&type=script&lang=ts&"
export * from "./ProjectChooser.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectChooser.vue?vue&type=style&index=0&id=32eba71b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32eba71b",
  null
  
)

export default component.exports